import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { ListOrganizationInvoiceRequestDto } from '@domain/organization-invoice/dto/list-organization-invoice.request.dto';
import { ListOrganizationInvoiceResponseDto } from '@domain/organization-invoice/dto/organization-invoice.response.dto';

@Injectable({
  providedIn: 'root',
})
export class OrganizationInvoiceService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('organization/invoice');
  }

  list(request: ListOrganizationInvoiceRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<ListOrganizationInvoiceResponseDto>>
    >(queryUrl, { params: { ...request } });
  }
}
